G.Candy = function(board, grid, postRandomPhase) {

  if (board && grid) {
  	this.grid = grid;
  	this.board = board;
  	this.boardCandies = board.boardCandies;
  }

	Phaser.Image.call(this,game,0,0);
	this.anchor.setTo(0.5);

  this.postRandomPhase = postRandomPhase || false;

	// this.wrapperImg = G.makeImage(0,0,'status_chain_2',0.5,null);

	this.anchor.setTo(0.5,0.5);

  // data
  this.baseTypeData = null;
  this.specialTypeData = null;

  this.baseType = null;
  this.candyStatus = null;

  this.signals = {

  };

	this.animationData = { 
		active: false
	};

	this.fallData = {
		alpha0: this.board ? this.board.cellYToPxIn(-1) : 0,
		alpha1: this.board ? this.board.cellYToPxIn(0) : 0,
		alphaDistance: this.board ? Math.abs(this.board.cellYToPxIn(-1) - this.board.cellYToPxIn(0)) : 0,
		active: false,
		delay: 0,
		targetY: 0,
		targetX: 0,
		velY: 0,
		grav: G.lnf(2.5),
	};
  

	this.kill();
	//this.init(cellX,cellY,type);

};

G.Candy.prototype = Object.create(Phaser.Image.prototype);


G.Candy.prototype.init = function(cellX,cellY,type) {
	this.resetProperties();
	
	this.cellX = cellX;
	this.cellY = cellY;
  if (this.board) {
  	this.x = this.board.cellXToPxIn(cellX);
  	this.y = this.board.cellYToPxIn(cellY);
  }

  this.import(type, true);

	// this.changeInto(type,true);

  this.revive();
};


G.Candy.prototype.resetProperties = function() {
  this.loadTexture(null);
  this.scale.setTo(1);
  this.alpha = 1;
  this.angle = 0;

  this.baseType = null;
  this.special = false;
  this.specialType = false;
  this.animationData.active = false;
  this.fallData.active = false;
  this.onMatchFx = false;
  this.activatedByMove = false;
  this.exe = [];
  this.matchable = true;
  this.goalCandy = false;
  
  this.removeStatus();
};


G.Candy.prototype.fallTo = function(cellX,cellY,delay) {

	this.setCell(cellX,cellY);
 
	if (!this.fallData.active) G.sb("onCandyFallStart").dispatch(this);
		
	this.fallData.active = true;
	this.fallData.delay = delay || 0;
	this.fallData.velY = G.IMMEDIATE ? 1000 : 0;
	this.fallData.targetY = this.board.cellYToPxIn(cellY);
	this.fallData.targetX = this.board.cellXToPxIn(cellX);


};

G.Candy.prototype.fallFrom = function(cellY,delay) {

		G.sb("onCandyFallStart").dispatch(this);
		this.y = this.board.cellYToPxIn(cellY);
		this.fallData.active = true;
		this.fallData.delay = delay || 0;
		this.fallData.velY = 0;
		this.fallData.targetX = this.board.cellXToPxIn(this.cellX);
		this.fallData.targetY = this.board.cellYToPxIn(this.cellY);
	
};

G.Candy.prototype.movedWith = function(candy) {
	this.lastMovedWith = candy;
};

G.Candy.prototype.markSuccessfulMove = function(candy) {
  this.baseType.onMove();
};

G.Candy.prototype.changeInto = function(type,skipAnim) {
  var candyDataMgr = G.Helpers.candyDataMgr;

	this.bringToTop();

	if (candyDataMgr.isTypeSpecial(type)) {
		var data = candyDataMgr.getSpecialData(type);
		this.setSpecialType(data, skipAnim);

	}else {
    var baseData = candyDataMgr.getBaseData(type);

    if (baseData) {
      this.setBaseType(baseData);
    } else {
      throw new Error("Can't find base type: "+type);
    }
	}
};

G.Candy.prototype.detachFromGrid = function() {
	this.boardCandies.grid.set(this.cellX,this.cellY,null);
};

G.Candy.prototype.hit = function() {
  if (this.candyStatus) {
    if (!this.candyStatus.onHit()) return;
  }

  if (!this.baseType.onHit()) return;

  return true;
};

G.Candy.prototype.update = function() {
	this.updateFall();
	this.updateAnimation();
};

G.Candy.prototype.updateFall = function() {

	if (this.fallData.active) { 
		if (this.fallData.delay > 0) return this.fallData.delay -= 1 * G.deltaTime;
		
		this.fallData.velY += this.fallData.grav*G.deltaTime;
		this.y += this.fallData.velY*G.deltaTime;


		//alpha during falling
		if (this.y < this.fallData.alpha1) {
			
			if (this.y < this.fallData.alpha0) {
				this.alpha = 0;
			}else { 
				this.alpha = Math.abs(this.fallData.alpha0-this.y)/this.fallData.alphaDistance;
			}

		}else {
			this.alpha = 1;
		}

		var xDif = this.fallData.targetX-this.x;
		var yDif = this.fallData.targetY-this.y;

		//changing collumn
		if (Math.abs(xDif) > yDif) {
			this.x = this.fallData.targetX - yDif*game.math.sign(xDif);
		}

		if (this.y > this.fallData.targetY) {
			this.y = this.fallData.targetY;
			this.x = this.fallData.targetX;
			this.fallData.active = false; 
			this.startAnimation('bounce');
			G.sfx['stone_impact_'+game.rnd.between(1,3)].play();
			G.sb("onCandyFallFinish").dispatch(this);
		}


	}

};

G.Candy.prototype.setCell = function(cellX,cellY) {

	if (this.grid.get(this.cellX,this.cellY) == this) {
		this.grid.set(this.cellX,this.cellY,null);
	}

	this.cellX = cellX;
	this.cellY = cellY;
	this.grid.set(cellX,cellY,this);

};

G.Candy.prototype.isGoalCandy = function() {
	return this.hasTag("goalCandy");
};

G.Candy.prototype.isBurntCandy = function() {
  return this.hasTag("burntCandy");
};

G.Candy.prototype.onBooster = function() {
  this.hit();

  // hack for special candies being triggered immediately
  // which effectively will have no effect
  if (this.hasSpecialType()) {
    this.board.checkSpecialMatchList.push(this);
  } else if (this.isMatchable()) {
    this.match();
    G.sfx.boom.play();
    G.lvl.processMatch(1,this.cellX,this.cellY);
  }

  return true;
};

G.Candy.prototype.match = function(delay,cellX,cellY) {

	if (!this.isMatchable()) return;
  if (this.animationData.active) return;  

  if (this.candyStatus) {
    if (!this.candyStatus.onMatch()) return;
  }

  if (this.specialType) {
    if (!this.specialType.onMatch()) return;
  }
  
  if (!this.baseType.onMatch()) return;

	this.detachFromGrid();

	G.sb("onCandyMatch").dispatch(this); 

	if (this.specialType) {
		this.specialType.startMatchFx();
		game.camera.shake(0.0075,250);
		this.boardCandies.thirdFloor.add(this);
		return this.startAnimation('growAndFade',delay);
	};


	if (G.lvl.isGoal(this.baseType.export())) {
		return this.remove();
	};


	if (typeof cellX == 'undefined') {
		this.startAnimation('vanishAlphaBurst',delay);
	}else {
		this.startAnimation('moveTo',[delay,cellX,cellY]);
	}

};

G.Candy.prototype.remove = function() {
	this.boardCandies.removeCandy(this);
};

G.Candy.prototype.dispatchCollectables = function() {
  if (!this.baseType.isAlreadyCollected()) {
    G.sb("onCollectableRemove").dispatch(
      this.getBaseTypeSymbol(),
      this.getSpecialTypeName() ? false : this);
  }

  if (this.hasSpecialType()) {
    G.sb("onCollectableRemove").dispatch(this.getSpecialTypeName(), this);
  }
};


G.Candy.prototype.updateAnimation = function() {

	if (this.animationData.active) {
		if (this.animationData.func) {
			this.animationData.func.call(this);
		}
		if (!this.animationData.active) {
			G.sb("onCandyAnimationFinish").dispatch();
		}
	}

};

G.Candy.prototype.startAnimation = function(type,args) {

	if (this.animationData.active) return alert("during another animation");

	if (this['animation-init-'+type]) {

		G.sb("onCandyAnimationStart").dispatch();
		this.animationData.active = true;

		this['animation-init-'+type](args);
		
	}

};

G.Candy.prototype['animation-init-bounce'] = function() {
	
	if (G.IMMEDIATE) {
		this.animationData.active = false;
		G.sb("onCandyAnimationFinish").dispatch(this);
		return;
	}

	game.add.tween(this).to({y : this.y-G.l(5)},100,Phaser.Easing.Sinusoidal.Out,true,0,0,true).onComplete.add(function() {
	//game.add.tween(this).to({y: this.y-G.l(5)},100,Phaser.Easing.Sinusoidal.InOut,true,0,0,true).onComplete.add(function() {
		this.animationData.active = false;
		G.sb("onCandyAnimationFinish").dispatch(this);
	//},this);
	},this);

};

G.Candy.prototype['animation-init-vanishAlphaBurst'] = function(delay) {

	G.sb("fx").dispatch('burstCandy',this,this);
	G.sb("onCandyAnimationFinish").dispatch(this);
	this.remove();

};



G.Candy.prototype['animation-init-growAndFade'] = function() {

	if (G.IMMEDIATE) {
		G.sb("onCandyAnimationFinish").dispatch(this);
		this.remove();
		return;
	}


	this.boardCandies.thirdFloor.add(this);
	this.bringToTop();
	var scaleTween = game.add.tween(this.scale).to({x:2.5,y:2.5},200,Phaser.Easing.Sinusoidal.In,true);
	game.add.tween(this).to({alpha:0},100,Phaser.Easing.Sinusoidal.In,true,100).onComplete.add(function() {
		scaleTween.stop();
		G.sb("onCandyAnimationFinish").dispatch(this);
		this.remove();
	},this);

};

G.Candy.prototype['animation-init-moveTo'] = function(args) {

	if (G.IMMEDIATE) {
		G.sb("onCandyAnimationFinish").dispatch(this);
		this.remove();
		return;
	}


	if (args[0]) {

		game.time.events.add(args[0],function() {
			var moveTween = game.add.tween(this).to({x:this.board.cellXToPxIn(args[1]),y:this.board.cellYToPxIn(args[2])},300,Phaser.Easing.Sinusoidal.In,true);
			game.add.tween(this).to({alpha: 0},200,Phaser.Easing.Sinusoidal.In,true,100).onComplete.add(function() {
				moveTween.stop();
				G.sb("onCandyAnimationFinish").dispatch(this);
				this.remove();
			},this);
			

		},this);

	}else {

		var moveTween = game.add.tween(this).to({x:this.board.cellXToPxIn(args[1]),y:this.board.cellYToPxIn(args[2])},300,Phaser.Easing.Sinusoidal.In,true);
			game.add.tween(this).to({alpha: 0},200,Phaser.Easing.Sinusoidal.In,true,100).onComplete.add(function() {
				moveTween.stop();
				G.sb("onCandyAnimationFinish").dispatch(this);
				this.remove();
			},this);

	}
	
};


G.Candy.prototype['animation-init-moveToCombo'] = function(args) {

		if (G.IMMEDIATE) {
			G.sb("onCandyAnimationFinish").dispatch(this);
			//game.time.events.add(1,this.remove,this);
			this.remove();
			return;
		}



		if (args[3] !== 0) {
			var rotateTween = game.add.tween(this).to({angle: args[3]},300,Phaser.Easing.Sinusoidal.InOut,true);

		}

		var moveTween = game.add.tween(this).to({x:this.board.cellXToPxIn(args[1]),y:this.board.cellYToPxIn(args[2])},300,Phaser.Easing.Sinusoidal.InOut,true);
			game.add.tween(this).to({alpha: 0.8},200,Phaser.Easing.Sinusoidal.In,true,200).onComplete.add(function() {
				moveTween.stop();
				if (rotateTween) rotateTween.stop();

				G.sb("onCandyAnimationFinish").dispatch(this);
				game.time.events.add(1,this.remove,this);

			},this);
};


G.Candy.prototype.moveTo = function(cellX,cellY,scale) {

	if (G.IMMEDIATE) {
		G.sb("onCandyAnimationFinish").dispatch(this);
		this.cellX = newCell[0];
		this.cellY = newCell[1];
		this.animationData.active = false;
		this.boardCandies.grid.set(this.cellX,this.cellY,this);
		return;
	}


	var candy = this.board.getCandy(cellX,cellY);
	var newCell = [cellX,cellY];

	this.bringToTop();

	G.sb("onCandyAnimationStart").dispatch();
	this.animationData.active = true;

	if (scale) {
		game.add.tween(this.scale).to({x:this.scale.x*2,y:this.scale.y*2},250,Phaser.Easing.Sinusoidal.InOut,true,0,0,true);
	}

	game.add.tween(this).to({x:this.board.cellXToPxIn(cellX),y:this.board.cellYToPxIn(cellY)},500,Phaser.Easing.Sinusoidal.InOut,true).onComplete.add(function() {
		G.sb("onCandyAnimationFinish").dispatch(this);
		this.cellX = newCell[0];
		this.cellY = newCell[1];
		this.animationData.active = false;
		this.boardCandies.grid.set(this.cellX,this.cellY,this);
	},this);

};

G.Candy.prototype.shuffleMoveToOwnCell = function() { 

	var orgParent = this.parent;

	if (this.hasSpecialType()) {
		this.boardCandies.thirdFloor.add(this);
	}else {
		this.boardCandies.secondFloor.add(this);
	}

	G.sb("onCandyAnimationStart").dispatch();
	this.animationData.active = true;

	game.add.tween(this).to({x:this.board.cellXToPxIn(this.cellX),y:this.board.cellYToPxIn(this.cellY)},500,Phaser.Easing.Sinusoidal.InOut,true).onComplete.add(function() {
		orgParent.add(this);
		G.sb("onCandyAnimationFinish").dispatch(this);
		this.animationData.active = false;
	},this);

};

G.Candy.prototype.export = function() {
  var expStr = this.baseType.export();

  if (this.specialType) {
    expStr += ":"+this.specialType.export();
  }

  if (this.candyStatus) {
    expStr += ":"+this.candyStatus.export();
  }

  // if (this.blocker) {
  //   expStr += ":B"+this.blockerHp;
  // }

  // if (this.wrapped) {
  //   expStr += ':W';
  // }
  // if (this.infected) {
  //   expStr += ':I';
  // }
  // if (this.specialType) {
  //   if (this.specialType == 'horizontal') {
  //     expStr += ":H";
  //   }
  //   if (this.specialType == 'vertical') {
  //     expStr += ":V";
  //   }
  //   if (this.specialType == 'cross') {
  //     expStr += ":C";
  //   }
  //   if (this.specialType == 'spiral') {
  //     expStr = "1:S";
  //   }
  // }

  return expStr;
};

G.Candy.prototype.import = function(importData, skipAnim) {
  var importStr = importData.toString();

  var candy = this;
  var candyDataMgr = G.Helpers.candyDataMgr;

  importStr.split(":")
    .forEach(function(chunk) {

      var editorSymbol = chunk.split("|")[0];
      var argsChunk = chunk.split("|")[1];

      var baseType = candyDataMgr.getBaseTypeByEditorSymbol(editorSymbol);
      if (baseType) {
        return this.setBaseType(baseType, argsChunk);
      }

      var specialType = candyDataMgr.getSpecialTypeByEditorSymbol(editorSymbol);
      if (specialType) {
        return this.setSpecialType(specialType, skipAnim, argsChunk);
      }

      var status = candyDataMgr.getStatusByEditorSymbol(editorSymbol);
      if (status) {
        return this.setStatus(status, argsChunk);
      }

    }, this);
};

G.Candy.prototype.setBaseType = function(data, args) {
  this.baseTypeData = data;

  if (data.layeredCake) {
    this.baseType = new G.BoardCandy.CakeType(this, data, args);
  } else if (data.infectionSource) {
    this.baseType = new G.BoardCandy.InfectionType(this, data ,args);
  } else if (data.chest) {
    this.baseType = new G.BoardCandy.ChestType(this, data ,args);
  } else if (data.fortuneCookie) {
    this.baseType = new G.BoardCandy.FortuneCookie(this, data, args);
  } else {
    this.baseType = new G.BoardCandy.CandyType(this, data, args);
  }

  this.baseType.signals.removeCandy.add(this.remove, this);
  this.baseType.signals.changeCandyTexture.add(function(sprite) {
    this.changeTexture(sprite);
  }, this);

  this.baseType.init(this, data, args);
};

G.Candy.prototype.setSpecialType = function(data, skipAnim) {
  if (!this.baseType) {
    return console.warn("no base type data");
  }

  if (!this.baseType.canHaveSpecialType()) {
    return console.warn(this.baseType.export() + " cannot have special type");
  }

  if (!skipAnim) {
    G.sb("fx").dispatch('changeCircle',this);
  }

  this.specialType = new G.BoardCandy.SpecialType();
  this.specialType.signals.removeCandy.add(this.remove, this);
  this.specialType.signals.changeCandyTexture.add(function(sprite) {
    this.changeTexture(sprite);
  }, this);
  this.specialType.init(this, data);
};

G.Candy.prototype.getSpecialType = function() {
  return this.specialType && this.specialType.getSpecialType();
};

G.Candy.prototype.clearSpecialType = function() {
  this.specialType = null;
  if (this.baseTypeData) this.setBaseType(this.baseTypeData);
};

G.Candy.prototype.setStatus = function(status, argsChunk) {
  if (this.candyStatus) this.removeStatus();

  if (status.wrapper) {
    this.candyStatus = new G.BoardCandy.RopeStatus();
  }

  if (status.chainMulti) {
    this.candyStatus = new G.BoardCandy.ChainStatus();
  }

  if (status.box) {
    this.candyStatus = new G.BoardCandy.BoxStatus();
  }

  // if (status.blocker) {
  //   this.changeIntoBlocker(argsChunk);
  // }

  if (status.infected) {
    this.candyStatus = new G.BoardCandy.InfectedStatus();
  }

  this.candyStatus.signals.checkIfIsMatching.add(function() {
    if (this.board) this.board.pushToFallCheckList(this);
  }, this);

  this.candyStatus.signals.onRemove.add(function() {
    if (this.board) this.board.pushToFallCheckList(this);
    this.candyStatus = null;
  }, this);

  this.candyStatus.init(this, status, argsChunk);
};

G.Candy.prototype.removeStatus = function(status) {
  if (this.candyStatus) {
    this.candyStatus.remove();
    this.candyStatus = null;
  }
};

G.Candy.prototype.hasStatus = function() {
  return Boolean(this.candyStatus);
};

G.Candy.prototype.isMatchable = function() {
  if (this.falling) return false;

  var matchable = this.baseType.isMatchable();
  
  if (this.specialType) {
    matchable = this.specialType.passMatchable(matchable);
  }

  if (this.candyStatus) {
    matchable = this.candyStatus.passMatchable(matchable);
  }

  return matchable;
};

G.Candy.prototype.isMatchableWith = function(otherCandy) {
  return this.isMatchable() && otherCandy.isMatchable()
    && this.getMatchToken() === otherCandy.getMatchToken();
};

G.Candy.prototype.getMatchToken = function() {
  var token = this.baseType.export();

  if (this.specialType && this.specialType.changeMatchToken) {
    token = this.specialType.changeMatchToken(token);
  }

  if (this.candyStatus && this.candyStatus.changeMatchToken) {
    token = this.candyStatus.changeMatchToken(token);
  }

  return token;
};

G.Candy.prototype.getBaseTypeSymbol = function() {
  return this.baseType.getEditorSymbol();
};

G.Candy.prototype.isRandom = function() {
  return this.baseType.hasTag("random");
};

G.Candy.prototype.isShuffleable = function() {
  return !this.hasTag("non-shufflable");
};

G.Candy.prototype.hasTag = function(tag) {
  if (this.baseType.hasTag(tag)) return true;
  if (this.candyStatus && this.candyStatus.hasTag(tag)) return true;
  if (this.specialType && this.specialType.hasTag(tag)) return true;

  return false;
};

G.Candy.prototype.hasSpecialType = function() {
  return Boolean(this.specialType);
};

G.Candy.prototype.getSpecialTypeName = function() {
  return this.specialType && this.specialType.getSpecialType();
};

G.Candy.prototype.isSpecialActivatedByMove = function() {
  return this.specialType && this.specialType.isActivatedByMove();
};

G.Candy.prototype.isFallingBlocked = function() {
  return this.baseType.FALLINGBLOCKED || false;
};

G.Candy.prototype.getSpecialExe = function() {
  return this.specialType && this.specialType.getExe();
};

G.Candy.prototype.hasEditorSymbol = function(symbol) {
  return  ((this.baseType && this.baseType.getEditorSymbol() === symbol)
    || (this.specialType && this.specialType.getEditorSymbol() === symbol)
    || (this.candyStatus && this.candyStatus.getEditorSymbol() === symbol))
};

G.Candy.prototype.hasExportString = function(symbol) {
  return  ((this.baseType && this.baseType.export() === symbol)
    || (this.specialType && this.specialType.export() === symbol)
    || (this.candyStatus && this.candyStatus.export() === symbol))
    || this.export() === symbol;
};

G.Candy.prototype.markPostRandomPhase = function() {
  this.postRandomPhase = true;
  if (this.hasStatus()) {
    this.candyStatus.markPostRandomPhase();
  }
};